// RBAC role that confers administrator privileges upon users of any account
import type { RoleName, RoleNames } from './system.models';

export const SYSTEM_ADMIN: RoleName = 'system-admin';

// RBAC roles that are system-wide in scope, ie not restricted to the user's account
export const systemRoles: RoleNames = [
  SYSTEM_ADMIN,
  'account-viewer',
  'license-override',
  'user-viewer',
];

export const SYSTEM_COMPONENTS = ['services', 'feeds'] as const;

export const SYSTEM_STATUS_ITEMS = ['system', ...SYSTEM_COMPONENTS] as const;

export const SYSTEM_ROLE_OPTIONS = systemRoles.map(role => ({
  key: role,
  text: role,
  value: role,
}));
